import React from 'react';
import clsx from 'clsx';
import { OrderSaleTab } from '../type';
import styles from '../products.module.scss';

const LoadingView: React.FC<{
  currentTab: OrderSaleTab;
  forTab: OrderSaleTab;
  className?: string;
}> = ({ currentTab, forTab, className }) => {
  const style =
    currentTab !== forTab
      ? clsx(styles.ordersSales__mainLeft__loading, styles['ordersSales__mainLeft__loading--neg'])
      : styles.ordersSales__mainLeft__loading;

  return (
    <div className={clsx(style, className)}>
      <div className={styles.ordersSales__mainLeft__loading__item} />
      <div className={styles.ordersSales__mainLeft__loading__item} />
      <div className={styles.ordersSales__mainLeft__loading__item} />
      <div className={styles.ordersSales__mainLeft__loading__item} />
    </div>
  );
};

export default LoadingView;
